/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".questionnaire-tag-layout[_ngcontent-%COMP%]{\n  margin: 0.3rem;\n  line-height: 0.3rem;\n}\n\n.questionnaire-tag-elem[_ngcontent-%COMP%]{\n  display: inline-block;\n  margin-right: 0.1rem;\n  margin-bottom: 0.2rem;\n  padding: 0.1rem;\n  font-size: 0.24rem;\n  color: rgb(191 193 199);\n  vertical-align: middle;\n  border: 0.02rem solid rgb(191,193,199);\n  border-radius: 0.1rem;\n}\n\n.questionnaire-tag-elem.active[_ngcontent-%COMP%]{\n  color:#7297e6;\n  border: 0.02rem solid #7297e6;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-tag/component.questionnaire-tag.css.shim.ngstyle.js.pre-build-optimizer.js